export default function backToTop() {
    const backToTopButton = document.getElementById('backToTop');
    if (!backToTopButton) return;

    const scrollMin = 600;
    const maxMobileWidth = 480;
    const inactivity_delay = 5000; // 5 secondes
    let isUpdateScheduled = false;
    let isReading = null;

    const isMobile = () => window.innerWidth < maxMobileWidth;
    const hideButton = () => {
        backToTopButton.style.display = 'none';
    };
    const showButton = () => {
        backToTopButton.style.display = 'flex';

        // Reset le timer à chaque scroll
        clearTimeout(isReading);
        // Ne pas afficher le bouton si inactif pour ne pas géner la lecture
        isReading = setTimeout(hideButton, inactivity_delay);
    };

    const updateButtonVisibility = () => {
        const hasScrolledEnough = window.scrollY > scrollMin;

        if (hasScrolledEnough && isMobile()) {
            showButton();
        } else {
            backToTopButton.style.display = 'none';
        }

        isUpdateScheduled = false;
    };

    const onScroll = () => {
        if (!isUpdateScheduled) {
            requestAnimationFrame(updateButtonVisibility);
            isUpdateScheduled = true;
        }
    };

    const scrollToTop = () => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({
            top: 0,
            behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateButtonVisibility, { passive: true });
    backToTopButton.addEventListener('click', scrollToTop);
}